import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { AuthClient } from 'app/auth/auth.client';
import { BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'out-of-service',
    templateUrl: 'out-of-service.component.html',
    styleUrls: ['out-of-service.component.scss']
})
export class OutOfServiceComponent {
    
    constructor(private _router: Router,
        private _route: ActivatedRoute,
        private _autoLoginClient: AutoLoginClient,
        private _authClient: AuthClient,
        private _toastService: BzgToastService,
        private _translateService: TranslateService) { }

    
public goHome() {
    const url = this._route.snapshot.queryParams['state'].split('___')[1];
    this._router.navigateByUrl(url);
}

    
}
